module.exports = __webpack_public_path__ + "img/northkorea.1777e2ae.svg";